import { ApiManager } from 'utlis/api_manager';

const api = new ApiManager(process.env.REACT_APP_BASE_URL);

export default class GoogleDocsService {
  static async getGoogleAuthLink(authCompleteURL) {
    return (await api.setUrl(`user/gdocs_connect/?return_url=${authCompleteURL}`).get()).data.url;
  }
}
